module.exports = __webpack_public_path__ + "static/media/analysis.d9951250.svg";